<div class="container" id="cooking-story-kitchen">
  <div class="cooking-kitchen-body">
    <div *ngIf="showLottie && isReady" class="animation">
      <ng-lottie
        width="240px"
        height="240px"
        [options]="options"
        [containerClass]="'lottie'"
        (animationCreated)="animationCreated($event)"
      ></ng-lottie>
      <div class="texts">
        <p>آشپزخانه شما خالی است.</p>
        <p>از دکمه‌ی زیر مواد غذایی موجود را اضافه کنید.</p>
      </div>
    </div>
    <div *ngIf="kitchenItems?.length > 0">
      <div
        class="posts"
        *ngIf="suggestPost && suggestPost.recipes.length > 0 && isReady"
      >
        <div class="pos-rel">
          <p class="post-category-title">{{ suggestPost.name }}</p>
          <p
            class="post-category-show-more"
            *ngIf="suggestPost.recipes && suggestPost.recipes.length >= 10"
            (click)="showCategory(suggestPost.type, suggestPost.name)"
          >
            همه
          </p>
        </div>

        <app-cooking-story-slider
          [ready]="isReady"
          [posts]="suggestPost"
          [suggest]="true"
        ></app-cooking-story-slider>
      </div>
      <div *ngIf="!isReady">
        <ngx-skeleton-loader
          animation="pulse"
          *ngIf="!isReady"
          [theme]="{
            'backgrund-color': '#eceef0',
            padding: '0 24px',
            margin: '0 24px',
            display: 'flex',
            height: '180px',
            'margin-top': '24px',
            'border-radius': '24px',
            'align-items': 'center',
            width: 'calc(100% - 48px)'
          }"
        ></ngx-skeleton-loader>
      </div>
      <div *ngIf="isReady">
        <ng-container *ngFor="let category of kitchenItems">
          <div
            class="kitchen-item"
            *ngIf="category.foods && category.foods.length > 0"
          >
            <div>
              <div class="kitchen-item-header">
                <img src="/assets/cookingbook/note.svg" alt="" />
                <p>{{ category.name }}</p>
              </div>
              <div class="kitchen-item-body">
                <ng-container *ngFor="let food of category.foods">
                  <div class="kitchen-item-food" *ngIf="!food.quickAdd">
                    <div class="flex">
                      <img
                        *ngIf="isSelecting"
                        [src]="
                          checkSelect(food._id)
                            ? 'assets/cookingbook/circle.svg'
                            : 'assets/cookingbook/circle_true.svg'
                        "
                        (click)="toggleSelect(food._id)"
                        alt=""
                      />
                      <p class="title" (click)="openEditFood(food)">
                        {{ getFoodName(food) }}
                      </p>
                    </div>
                    <div class="content" (click)="openEditFood(food)">
                      <img
                        src="assets/cookingbook/comment.svg"
                        *ngIf="hadComment(food)"
                        alt=""
                      />
                      <p class="exp">
                        {{ getFoodEXP(food) }}
                      </p>
                      <img
                        src="/assets/cookingbook/angle_left_blue.svg"
                        alt=""
                      />
                    </div>
                  </div>
                  <div
                    class="kitchen-item-food"
                    (click)="openQuickEditFood(food._id)"
                    *ngIf="food.quickAdd"
                  >
                    <div class="flex">
                      <img
                        *ngIf="isSelecting"
                        (click)="toggleSelect(food._id)"
                        [src]="
                          checkSelect(food._id)
                            ? 'assets/cookingbook/circle.svg'
                            : 'assets/cookingbook/circle_true.svg'
                        "
                        alt=""
                      />
                      <p class="title">
                        {{ getFoodName(food) }}
                      </p>
                    </div>
                    <div class="content">
                      <p class="exp">
                        {{ getFoodEXP(food) }}
                      </p>
                      <img
                        src="/assets/cookingbook/angle_left_blue.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div *ngIf="!isReady">
        <ngx-skeleton-loader
          *ngFor="let i of gArr(3)"
          animation="pulse"
          [theme]="{
            'backgrund-color': '#eceef0',
            padding: '0 24px',
            margin: '0 24px',
            display: 'flex',
            height: '48px',
            'margin-top': '24px',
            'border-radius': '12px',
            'align-items': 'center',
            width: 'calc(100% - 48px)'
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
  </div>
  <div class="button-holder-move" [ngClass]="{ show: selectedItem.length > 0 }">
    <div class="remove" (click)="removeAll()">حذف همه</div>
  </div>
  <div class="button-holder" [ngClass]="{ show: selectedItem.length == 0 }">
    <div class="add-button" *ngIf="isReady" (click)="goTosearch()">
      <img src="../../../../../assets/cookingbook/plus-fill.svg" alt="" />
      <p>افزودن غذا</p>
    </div>

    <ngx-skeleton-loader
      *ngIf="!isReady"
      animation="pulse"
      [theme]="{
        'backgrund-color': '#eceef0',
        height: '56px',
        'border-radius': '24px',
        width: 'calc(calc(100vw / 2 ) - 48px)'
      }"
    ></ngx-skeleton-loader>
    <!-- <ngx-skeleton-loader
      *ngIf="!isReady"
      animation="pulse"
      [theme]="{
        'backgrund-color': '#eceef0',
        height: '56px',
        'border-radius': '24px',
        width: 'calc(calc(100vw / 2 ) - 48px)'
      }"
    ></ngx-skeleton-loader> -->
    <!-- <div class="quick-add-button" *ngIf="isReady" (click)="openQuickAdd()">
      <img src="assets/cookingbook/plus-fill-full.svg" alt="" />
      <p>افزودن سریع</p>
    </div> -->
  </div>
</div>
